import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-update-pet-details-info-modal',
  templateUrl: './update-pet-details-info-modal.component.html'
})
export class UpdatePetDetailsInfoModalComponent {

  constructor(
    public activeModal: NgbActiveModal,
    private _router: Router
  ) { }

  public navigateToMyPets() {
    this.activeModal.dismiss();
    this._router.navigate(['/my-pets']);
  }

}
